import { ExchangeRateDate } from '@g2-shared/api-client/generated/settlement-app';

export const ExchangeRateDateLabelMapper: Record<ExchangeRateDate, string> = {
  [ExchangeRateDate.NONE]: 'None',
  [ExchangeRateDate.SETTLEMENT_DATE]: 'Settlement_date',
  [ExchangeRateDate.TRANSACTION_DATE]: 'Transaction_date',
};
